import Vue from "vue";
import App from "@/views/Hot/Index.vue";
import store from "../../store/hot";
import ElementUI from "element-ui";
import "@/assets/fade-in.css";
import "@/assets/element-variables.scss";
import "@/assets/normalize.scss";
import "@/assets/iconfont.css";
import "@/assets/global.scss";
import systemInit from "@/utils/system";
import trackDirectives from "@/utils/tracker.js";
import { isHeadlessBrowser } from "@/utils/common";
import STATIC_DATA from "@/utils/constants/gjxx.js";

Vue.config.productionTip = false;
console.log("process.env:", process.env);
Vue.use(ElementUI);
Vue.use(trackDirectives);

systemInit.basicFunctionInit();
systemInit.basicListenersInit();

function innerAPP() {
  if (!isHeadlessBrowser() && window._STATIC_DATA_ && process.env.NODE_ENV === "production") {
    const data = window._STATIC_DATA_();
    store.commit("hot/updateData", { ...STATIC_DATA, ...data });
  } else {
    console.log(STATIC_DATA)
    store.commit("hot/updateData", {...STATIC_DATA});
  }

  new Vue({
    render: (h) => h(App),
    store,
    mounted() {},
  }).$mount("#app");
}
innerAPP();
